window.TeamLiveScheduleBudgetingAPI = new (function () {
    "use strict";

    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['ScheduleBudgeting']);

    self.getBudgetWeeks = function (brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + brandId + '/budget_weeks';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getAllLocationsBudgetWeeks = function (brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + brandId + '/locations/budget_weeks';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.budgetWeeksExport = function (brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + brandId + '/budget_weeks/export';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getBudgetUploadFileHistory = function (brandId, param) {
        var defer = $q.defer();
        var url = 'brands/' + brandId + '/budget_files/history';

        _protected.request(url, 'GET', param)
            .then(function (response) {
                if (response.data && response.data.data && response.data.data.budget_files && response.status === 200) {
                    defer.resolve(response.data.data.budget_files);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getBudgetWeeksTemplateUrl = function (brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + brandId + '/budget_weeks/template';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getPreSignedUrl = function (brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + brandId + '/presigned_url';

        _protected.request(url, 'GET', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.uploadBudgetFile = function (brandId, params) {
        var defer = $q.defer();
        var url = 'brands/' + brandId + '/budget_files';

        _protected.request(url, 'POST', params)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getBudgetFilesByStatus = function (brandId, status) {
        var defer = $q.defer();
        var url = 'brands/' + brandId + '/budget_files?status='+status;

        _protected.request(url, 'GET',{})
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getBudgetFileById = function (brandId, fileId) {
        var defer = $q.defer();
        var url = 'brands/' + brandId + '/budget_files/'+fileId;

        _protected.request(url, 'GET',{})
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.approveBudgetFileOverwrite = function (brandId, fileId) {
        var defer = $q.defer();
        var url = 'brands/' + brandId + '/budget_files/'+fileId+'/approve';

        _protected.request(url, 'POST',{})
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.cancelBudgetFileOverwrite = function (brandId, fileId) {
        var defer = $q.defer();
        var url = 'brands/' + brandId + '/budget_files/'+fileId+'/cancel';

        _protected.request(url, 'POST',{})
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getBudgetingHours = function (brandId, week) {
        var defer = $q.defer();
        var url = 'brands/' + brandId + '/stats/budget';
        var params = {week: week};

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request(url, 'GET', params)
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data.stats_budget || {});
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getBudgetSettings = function (brandId) {
        var defer = $q.defer();
        var url = 'brands/' + brandId + '/budget/settings';

        _protected.request(url, 'GET',{})
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.updateBudgetSettings = function (brandId, payload) {
        var defer = $q.defer();
        var url = 'brands/' + brandId + '/budget/settings';

        _protected.request(url, 'PUT', payload)
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

    self.getBudgetMetrics = function (brandId) {
        var defer = $q.defer();
        var url = 'brands/' + brandId + '/budget/settings/metrics';

        _protected.request(url, 'GET',{})
            .then(function (response) {
                if (response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    };

})();
